import React from 'react';
import Container from '../../../containers/integration/webhooks/editWebhookContainer';

export default function () {
  return (
    <Container />
  );
}
